/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, window: NonNullable<unknown> }} Endpoint_Reference_Verified_WindowInputs */

const en_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last verified ${i?.day} · uptime and latency measured over ${i?.window}`)
};

const zh_hans1_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最近验证于 ${i?.day} · 可用率和延迟按 ${i?.window} 统计`)
};

const pt_br2_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última verificação em ${i?.day} · disponibilidade e latência medidas em ${i?.window}`)
};

const es_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificado por última vez el ${i?.day} · disponibilidad y latencia medidas en ${i?.window}`)
};

const fr_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière vérification : ${i?.day} · disponibilité et latence mesurées sur ${i?.window}`)
};

const de_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt geprüft ${i?.day} · Verfügbarkeit und Latenz gemessen über ${i?.window}`)
};

const ru_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проверено ${i?.day} · доступность и задержка измерены за ${i?.window}`)
};

const it_endpoint_reference_verified_window = /** @type {(inputs: Endpoint_Reference_Verified_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima verifica ${i?.day} · disponibilità e latenza misurate su ${i?.window}`)
};

/**
* | output |
* | --- |
* | "Last verified {day} · uptime and latency measured over {window}" |
*
* @param {Endpoint_Reference_Verified_WindowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_verified_window = /** @type {((inputs: Endpoint_Reference_Verified_WindowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Verified_WindowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_verified_window(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_verified_window(inputs)
	if (locale === "es") return es_endpoint_reference_verified_window(inputs)
	if (locale === "fr") return fr_endpoint_reference_verified_window(inputs)
	if (locale === "de") return de_endpoint_reference_verified_window(inputs)
	if (locale === "ru") return ru_endpoint_reference_verified_window(inputs)
	if (locale === "it") return it_endpoint_reference_verified_window(inputs)
	return en_endpoint_reference_verified_window(inputs)
});